import React from 'react'

import { Spinner } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import Pagination from 'Pods/Shared/Components/Pagination/Pagination'
import LegacyDataTable from 'Pods/Shared/DataTable/LegacyDataTable'

import EmptyMessage from './EmptyMessage'
import ModelWithImage from './ModelWithImage'
import { useSubscriptionsContext } from '../Context/SubscriptionsContext'

function EligibleModels() {
  const {
    eligibleModels,
    isLoadingEligible,
    hasFetchedEligible,
    eligiblePaginationMeta,
    eligibleFilters,
    setEligibleFilters,
    translate,
  } = useSubscriptionsContext()

  const handleSort = (key, direction) => {
    setEligibleFilters({
      ...eligibleFilters,
      page: 1,
      sortKey: direction ? key : null,
      sortDirection: direction,
    })
  }

  const columnsConfig = {
    id: { visible: false },
    smallImage: { visible: false },
    subscriptionOptInDate: { visible: false },
    name: {
      title: translate('my_subscriptions.eligible_models.column_models'),
      position: 1,
    },
    publishingDate: {
      title: translate('my_subscriptions.eligible_models.column_publishing_date'),
      position: 2,
      width: '180px',
      sortable: true,
    },
    subscriptionOptInDateDisplay: {
      title: translate('my_subscriptions.eligible_models.column_opt_in_date'),
      position: 3,
      width: '220px',
      sortable: false,
    },
  }

  const dataWithOptInDate = eligibleModels.map((model) => ({
    ...model,
    subscriptionOptInDateDisplay: model.subscriptionOptInDate,
  }))

  return (
    <div className="eligible-models">
      <div className="eligible-models__description cgt-mb-20">
        <p className="cgt-mb-0 cgt-legacy-text-default">
          {translate('my_subscriptions.eligible_models.description_line1')}
        </p>
        <p className="cgt-mb-0 cgt-legacy-text-default">
          {translate('my_subscriptions.eligible_models.description_line2')}
        </p>
      </div>
      <div className="eligible-models__content">
        {(isLoadingEligible || !hasFetchedEligible) ? (
          <div className="eligible-models__loader">
            <Spinner size="small" />
          </div>
        ) : (
          <LegacyDataTable
            data={dataWithOptInDate}
            EmptyMessage={(
              <EmptyMessage
                title={translate('my_subscriptions.eligible_models.empty_title')}
                description={translate('my_subscriptions.eligible_models.empty_description')}
              />
            )}
            columnsConfig={columnsConfig}
            sortKey={eligibleFilters.sortKey}
            sortDirection={eligibleFilters.sortDirection}
            onSort={handleSort}
            renderCustomCell={{
              name: (name, row) => (
                <ModelWithImage
                  name={name}
                  imageUrl={row.smallImage}
                  imageAlt={name}
                />
              ),
            }}
          />
        )}
      </div>
      {(hasFetchedEligible && eligiblePaginationMeta.totalCount > 0) && (
        <Pagination
          currentPage={eligiblePaginationMeta.currentPage}
          totalPages={Math.max(eligiblePaginationMeta.totalPages, 1)}
          totalCount={eligiblePaginationMeta.totalCount}
          perPage={eligiblePaginationMeta.perPage}
          onPageChange={(newPage) => setEligibleFilters({
            ...eligibleFilters,
            page: newPage,
          })}
          onPerPageChange={(newPerPage) => setEligibleFilters({
            ...eligibleFilters,
            page: 1,
            perPage: newPerPage,
          })}
          alwaysShow
        />
      )}
    </div>
  )
}

export default EligibleModels
